import { MessageCircle } from "lucide-react";

/* Single user-facing contact. The label reads like an email by choice, but it is a Facebook Messenger link — never mailto:. */
export const CONTACT = { label: "talk@dropit.fyi", href: "https://m.me/61595245687815", kind: "messenger" };
const HINT = "Opens Facebook Messenger";

export const ContactLink = ({ className = "", testid = "contact-link" }) => (
  <a href={CONTACT.href} target="_blank" rel="noopener noreferrer" title={HINT} className={`inline-flex items-center gap-1 underline underline-offset-2 notranslate ${className}`} translate="no" data-testid={testid} data-kind={CONTACT.kind}>
    <MessageCircle size={14} className="shrink-0" aria-hidden="true" />{CONTACT.label}<span className="sr-only"> ({HINT})</span>
  </a>
);

export const MessageUsButton = ({ className = "btn-secondary", testid = "message-us-button" }) => (
  <a href={CONTACT.href} target="_blank" rel="noopener noreferrer" title={HINT} className={`${className} inline-flex items-center justify-center gap-2 no-underline`} data-testid={testid} data-kind={CONTACT.kind}>
    <MessageCircle size={16} aria-hidden="true" /> Message us<span className="sr-only"> ({HINT})</span>
  </a>
);
